<template lang="pug">
    layout(:page="'auth'")
        template(slot="title")

            // Title
            title-component(:title="$t('auth.firstLogin.title')" type="h1")

            // Message
            div(v-html="$t('auth.firstLogin.message')")

        // Login form
        confirm-form
</template>

<script>
    import ConfirmPasswordFrom from './ConfirmPasswordForm';
    import Layout from '../Layout';
    import Title from '~components/Title';

    export default {
        components: {
            ConfirmForm: ConfirmPasswordFrom,
            Layout,
            TitleComponent: Title
        }
    };
</script>
